import React from "react";
import {MtplQuotation, Quotation} from "../model/quotation";
import {QuoationPackage, SalesProgramOption} from "../model/quoationPackage";
import {VehicleGroup, VehicleType} from "../model/vehicle";
import {ProductType} from "../api/model/common";


export interface QuotationContext<T extends Quotation> {
    quotation: T;
    type: ProductType
    setQuotation: (value: any) => void;
    totalPremium: number;
    setTotalPremium: (premium: number) => void;
    packages: QuoationPackage[];
    setPackages: (value: QuoationPackage[]) => void;
    selectedDeductible: number;
    setSelectedDeductible: (value: number) => void;
    selectedPackage: QuoationPackage;
    setSelectedPackage: (value: QuoationPackage) => void;
    selectedProgram: SalesProgramOption;
    setSelectedProgram: (value: SalesProgramOption) => void;
    selectedVtplCovered: boolean;
    setSelectedVtplCovered: (value: boolean) => void;
    selectedVtplSumInsured: number;
    setSelectedVtplSumInsured: (value: number) => void;
    selectedVtplPremium: number;
    setSelectedVtplPremium: (premium: number) => void;
    isQuotationEditable: boolean;
    setIsQuotationEditable: (isQuotationEditable: boolean) => void;
    agreeOption1: boolean;
    setAgreeOption1: (agree: boolean) => void;
    agreeInformOption: boolean;
    setAgreeInformOption: (agree: boolean) => void;
    agreeOption2: boolean;
    setAgreeOption2: (agree: boolean) => void;
    selectedView: string;
    setSelectedView: (value: string) => void;
    vehicleTypes: VehicleType[];
    setVehicleTypes: (value: VehicleType[]) => void;
    vehicleGroup: VehicleGroup;
    setVehicleGroup: (value: VehicleGroup) => void;
    vehicleFounded: boolean;
    setVehicleFounded: (value: boolean) => void;
    tarrificationProgram: string;
    setTarrificationProgram: (value: string) => void,
    isMtplPhoneNumberDialogOpen: boolean,
    setMtplPhoneNumberDialogOpen: (value: boolean) => void,
    saveTempValues: (endName:string, value:string) => void,
    defaultPlateNumber: string,
    isRemembered: boolean,
    defaultTariffied: boolean
}

export const QuotationContext = React.createContext<QuotationContext<MtplQuotation>>({
    quotation: null,
    type: null,
    setQuotation: () => {},
    totalPremium: null,
    setTotalPremium: () => {},
    packages: null,
    setPackages: () => {},
    selectedDeductible: null,
    setSelectedDeductible: () => {},
    selectedPackage: null,
    setSelectedPackage: () => {},
    selectedProgram: null,
    setSelectedProgram: () => {},
    selectedVtplCovered: null,
    setSelectedVtplCovered: () => {},
    selectedVtplSumInsured: null,
    setSelectedVtplSumInsured: () => {},
    selectedVtplPremium: null,
    setSelectedVtplPremium: () => {},
    isQuotationEditable: null,
    setIsQuotationEditable: () => {},
    agreeOption1: false,
    setAgreeOption1: () => {},
    agreeInformOption: false,
    setAgreeInformOption: () => {},
    agreeOption2: false,
    setAgreeOption2: () => {},
    selectedView: null,
    setSelectedView: () => {},
    vehicleTypes: null,
    setVehicleTypes: () => {},
    vehicleGroup: null,
    setVehicleGroup: () => {},
    vehicleFounded: null,
    setVehicleFounded: () => {},
    tarrificationProgram: null,
    setTarrificationProgram: () => {},
    isMtplPhoneNumberDialogOpen: true,
    setMtplPhoneNumberDialogOpen: () => {},
    saveTempValues: () => {},
    defaultPlateNumber: "",
    isRemembered: false,
    defaultTariffied: false
});
